/** Primary Payroll Setup tabs (Brixigo-style numbered sections). */
export const PAYROLL_SETUP_TABS = [
  { id: "settings", to: "/salary-v2/setup", label: "3.1 Payroll Settings", shortLabel: "3.1 Settings" },
  { id: "overtime", to: "/salary-v2/overtime", label: "Overtime Works", shortLabel: "Overtime" },
  { id: "extra-work", to: "/salary-v2/extra-work", label: "Premium Works", shortLabel: "Premium" },
  { id: "components", to: "/salary-v2/components", label: "3.2 Salary Components", shortLabel: "3.2 Components", end: false },
  { id: "structures", to: "/salary-v2/structures", label: "3.3 Salary Structures", shortLabel: "3.3 Structures" },
];

/** Advanced payroll tools — kept accessible but not in the primary tab bar. */
export const PAYROLL_ADVANCED_TABS = [
  { to: "/salary-v2/formula-builder", label: "Formula Builder" },
  { to: "/salary-v2/derived-variables", label: "Derived Variables" },
  { to: "/salary-v2/user-guide", label: "User Guide" },
  { to: "/salary-v2/benefits-deductions", label: "Benefits & Deductions" },
  { to: "/salary-v2/groups", label: "Component Groups" },
  { to: "/salary-v2/scheduled", label: "Scheduled" },
  { to: "/salary-v2/arrears", label: "Arrears" },
  { to: "/salary-v2/statutory", label: "Statutory" },
  { to: "/salary-v2/simulator", label: "Simulator" },
  { to: "/salary-v2/dependencies", label: "Dependencies" },
  { to: "/salary-v2/audit", label: "Audit" },
  { to: "/tools/ctc-planner", label: "CTC Planner", external: true },
  { to: "/settings/statutory", label: "Compliance", external: true },
];
